export type IngestRunActivityFields = {
  status: string;
  progress_label?: string | null;
  progress_current?: number | null;
  progress_total?: number | null;
};

export function IngestRunActivityCell({ run }: { run: IngestRunActivityFields }) {
  if (run.status !== "running") {
    return <span className="text-slate-300">—</span>;
  }
  const label = typeof run.progress_label === "string" ? run.progress_label.trim() : "";
  if (!label) {
    return <span className="text-xs text-slate-400">Starting…</span>;
  }
  const cur = run.progress_current;
  const tot = run.progress_total;
  const hasFraction = cur != null && tot != null && tot > 0;
  const curN = hasFraction ? Math.min(Number(cur), Number(tot)) : 0;
  const totN = hasFraction ? Number(tot) : 0;
  return (
    <div className="max-w-[16rem]">
      <div className="text-xs leading-snug text-slate-800">{label}</div>
      {hasFraction ? (
        <div className="mt-0.5 text-xs tabular-nums text-slate-600">
          <span className="font-medium text-slate-800">{curN.toLocaleString()}</span>
          {" of "}
          <span className="font-medium text-slate-800">{totN.toLocaleString()}</span>
          {" records processed"}
        </div>
      ) : null}
    </div>
  );
}
